import React  from 'react';  

export const appointmentConfig = [
  {
    auth: ['user'],
    routes: [
      {
        exact: true,
        path: '/appointment',
        component: React.lazy(() => import('./AppointmentTabs')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        exact: true,
        path: '/appointment/book-new-appointment',
        component: React.lazy(() => import('./AppointmentTabs')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        exact: true,
        path: '/appointment/other-services',
        component: React.lazy(() => import('./AppointmentTabs')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        exact: true,
        path: '/appointment/book-other-services',
        component: React.lazy(() => import('./AppointmentTabs')),
      },
    ],
  },
   {
    auth: ['user'],
    routes: [
      {
        exact:false,
        path: '/appointment/consent-flow',
        component: React.lazy(() => import('./ConsentFlow')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        exact:false,
        path: '/appointment/edit-appointment',
        component: React.lazy(() => import('./EditAppointment')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        exact:false,
        path: '/appointment/appointment-success',
        component: React.lazy(() => import('./BookNewAppointment/AppAppointmentSuccess')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        exact:false,
        path: '/appointment/other-services/other-services-success',
        component: React.lazy(() => import('./BookNewAppointment/OtherServiceSuccess')),
      },
    ],
  },
  // {
  //   auth: ['user'],
  //   routes: [
  //     {
  //       exact:false,
  //       path: '/checkout',
  //       component: React.lazy(() => import('./BookNewAppointment/CheckoutForm')),
  //     },
  //   ],
  // },
  {
    auth: ['user'],
    routes: [
      {
        exact:false,
        path: '/return',
        component: React.lazy(() => import('./BookNewAppointment/Return')),
      },
    ],
  },
  {
  auth: ['user'],
  routes: [
    {
      exact: true,
      path: '/appointment/book-other-services-new',
      component: React.lazy(
        () => import('./BookOtherServices/BookOtherServicePostgres')
      ),
    },
  ],
},
];